import { themes } from "./themeConfig";

export const useThemes = (designTemplate) => {
  return themes[designTemplate] || themes.default;
};